import { BotBalance } from "./formats";

const BalancePercentage = ({
  balance,
  maxBalance,
}: {
  balance: number;
  maxBalance?: number;
}) => {
  const balancePercentage = (balance / (maxBalance || 1)) * 100;

  return (
    <div>
      <BotBalance value={balance} />
      <div className="w-[5rem] relative h-[0.125rem] bg-blue bg-opacity-25">
        <div
          className="absolute left-0 top-0 bottom-0 bg-blue max-w-[5rem]"
          style={{ width: `${balancePercentage}%` }}
        />
      </div>
    </div>
  );
};

export default BalancePercentage;
